import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Spinner } from 'reactstrap';
import { Entrycameramonitor } from '../../../../api/EntryCameraMonitorifl';
import FaceDetectionsTable from './FaceDetectionsTable';
import FiltersComponent from '../components/Filters/FiltersComponent';
import { getCurrentcompleteDate } from '../../../../utils/getCurrentcompleteDate';
import { errorToast } from '../../../../_helper/helper';
import './faceDetections.css';

const LOCAL_STORAGE_KEY = 'faceDetectionsFilters';

const sampleData = [
  {
    log_id: 16560,
    factory_name: "ytml7_facial",
    employee_id: "ytm7_unknown",
    employee_name: "unknown",
    blacklisted: false,
    employee_designation: "Intruder",
    camera_id: "ytm_150.15.209.58",
    camera_name: "Out",
    camera_position_no: "Gate Out",
    detection_datetime: "2025-07-17 06:54:31",
    sop_followed: false,
    face_image_url: "https://storage.googleapis.com/ytml-disruptlabs/person_data/person_data/Out/2025-07-17/non_sop/ZMQ_SideOnly_5744_20250717_065431_ac89eaa1/ZMQ_SideOnly_5744_20250717_065431_ac89eaa1_065431_001.jpg",
  },
  {
    log_id: 16561,
    factory_name: "ytml7_facial",
    employee_id: "ytm7_unknown",
    employee_name: "unknown",
    blacklisted: false,
    employee_designation: "Intruder",
    camera_position_no: "Gate Out",
    detection_datetime: "2025-07-17 06:54:31",
    sop_followed: false,
    face_image_url: "https://storage.googleapis.com/ytml-disruptlabs/person_data/person_data/Out/2025-07-17/non_sop/ZMQ_SideOnly_5744_20250717_065431_ac89eaa1/ZMQ_SideOnly_5744_20250717_065431_ac89eaa1_065431_001.jpg",
  },
  {
    log_id: 16559,
    employee_id: "ytm7_unknown",
    employee_name: "ali",
    blacklisted: false,
    employee_designation: "Intruder",
    camera_position_no: "Gate In",
    detection_datetime: "2025-07-17 06:54:15",
    sop_followed: false,
    face_image_url: "https://storage.googleapis.com/ytml-disruptlabs/person_data/person_data/In/2025-07-17/ZMQ_Unknown_5730_20250717_065415_17d0f469/ZMQ_Unknown_5730_20250717_065415_17d0f469_065415_001.jpg",
  },
  {
    log_id: 16558,
    employee_id: "Younus",
    employee_name: "unknown",
    blacklisted: false,
    employee_designation: "Intruder",
    camera_position_no: "Gate In",
    detection_datetime: "2025-07-17 06:54:12",
    sop_followed: false,
    face_image_url: "https://storage.googleapis.com/ytml-disruptlabs/person_data/person_data/In/2025-07-17/non_sop/ZMQ_SideOnly_5727_20250717_065412_7b453855/ZMQ_SideOnly_5727_20250717_065412_7b453855_065412_001.jpg",
  },
];

const FaceDetectionsTablePage = ({ statsLoader, handleImageClick }) => {
  const getInitialFilters = () => {
    const savedFilters = localStorage.getItem(LOCAL_STORAGE_KEY);
    return savedFilters
      ? JSON.parse(savedFilters)
      : {
        selectDate: 'date',
        time: '',
        week: '',
        date: getCurrentcompleteDate(),
        month: '',
        shift: '',
        starting: '',
        ending: ''
      };
  };

  const [filters, setFilters] = useState(getInitialFilters);
  const [livealertsdata, setLivealertsdata] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLivealertsdata(sampleData);
    setLoading(false);

    // When ready to use API:
    fetchFaceDetections();
  }, []);

  const handleSave = () => {
    const updatedFilters = {
      selectDate: filters.selectDate,
      time: '',
      week: '',
      date: '',
      month: '',
      shift: filters.shift,
      starting: '',
      ending: '',
    };

    switch (filters.selectDate) {
      case 'date':
        if (!filters.date) {
          errorToast('Please select a Date!');
          return;
        }
        updatedFilters.date = filters.date;
        break;
      case 'week':
        if (!filters.week) {
          errorToast('Please select a Week!');
          return;
        }
        updatedFilters.week = filters.week;
        break;
      case 'month':
        if (!filters.month) {
          errorToast('Please select a Month!');
          return;
        }
        updatedFilters.month = filters.month;
        break;
      case 'custom':
        if (!filters.starting || !filters.ending) {
          errorToast('Please select both Starting and Ending Dates!');
          return;
        }
        updatedFilters.starting = filters.starting;
        updatedFilters.ending = filters.ending;
        break;
      default:
        break;
    }

    fetchFaceDetections();
    setFilters(updatedFilters);
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updatedFilters));
  };

  const handleCancel = () => {
    const updatedFilters = {
      selectDate: 'date',
      time: '',
      week: '',
      date: getCurrentcompleteDate(),
      month: '',
      shift: '',
      starting: '',
      ending: ''
    };

    fetchFaceDetections();
    setFilters(updatedFilters);
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updatedFilters));
  };

  const fetchFaceDetections = async () => {
    try {
      setLoading(true);
      const userData = JSON.parse(localStorage.getItem('userData'));

      const payload = {
        client_id: userData?.client?.id,
        factory_id: userData?.factory?.id,
        limit: 100,
        offset: 0,
        camera_id: "",
        employee_id: "",
        user_type: "contractor",
        filters: {
          date: filters?.date,
          week: filters?.week,
          month: filters?.month,
          starting: filters?.starting,
          ending: filters?.ending,
        },
      };

      const res = await Entrycameramonitor.getAllEmplyoes(payload);
      if (res.status === 200) {
        setLivealertsdata(res?.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching face detections:", error);
    } finally {
      setLoading(false);
    }
  };

  function getFilterLabel(filters) {
    switch (filters.selectDate) {
      case 'date':
        return filters.date ? `Date: ${filters.date}` : '';
      case 'week':
        return filters.week ? `Week: ${filters.week}` : '';
      case 'month':
        return filters.month ? `Month: ${filters.month}` : '';
      case 'custom':
        if (filters.starting && filters.ending) {
          return `Custom: ${filters.starting} to ${filters.ending}`;
        }
        return '';
      default:
        return '';
    }
  }

  return (
    <Container fluid className="dashboard-first-page">
      <Row className="mb-3">
        <Col>
          <h1 style={{ fontSize: "24px", color: "#1e67d6", fontWeight: "600" }}>Face Detections Table</h1>
          <p style={{ color: "#535353", fontSize: "14px" }}>
            {getFilterLabel(filters)}
          </p>
        </Col>
        <Col xs="12" xl="9" className="d-flex flex-wrap justify-content-end align-items-end mb-2">
          <FiltersComponent
            setFilters={setFilters}
            filtersConfig={[
              { key: "selectDate", options: ["date", "week", 'month', 'custom'], placeholder: "date" },
            ]}
            handleSave={handleSave}
            handleCancel={handleCancel}
            filters={filters}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          {loading ? (
            <div className="d-flex justify-content-center py-5">
              <Spinner color="success" style={{ width: "3rem", height: "3rem" }} />
            </div>
          ) : (
            <FaceDetectionsTable handleImageClick={handleImageClick} data={livealertsdata} />
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default FaceDetectionsTablePage;
